/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { injectable } from 'inversify';

const eventBus = require('js-event-bus')();

const DEFAULT_CONFIG = {
  name: 'event-bus-module',
};

@injectable()
export class EventBusModule {
  name = DEFAULT_CONFIG?.name;
  private eventBus: any;
  static displayName = 'EventBusModule';

  constructor() {
    this.eventBus = eventBus;
  }

  async init() {}
  getEventBus() {
    return this.eventBus;
  }
}
